import { motion } from "framer-motion";
import { Overline } from "../Reveal";

const chapters = [
  {
    n: "01",
    title: "Inteligencia",
    body: "Anticipamos la amenaza antes de que exista. OSINT profundo e IA para mapear tu superficie de ataque como lo haría un adversario real.",
  },
  {
    n: "02",
    title: "Cyber Defense",
    body: "Tus datos, bajo tu control absoluto. Arquitecturas de defensa donde nada sale de tu perímetro sin tu permiso explícito.",
  },
  {
    n: "03",
    title: "Ofensiva",
    body: "Pensamos como el atacante para blindar tu defensa. Red Team y pentesting de precisión que exponen lo que otros no ven.",
  },
];

const IMG =
  "https://images.unsplash.com/photo-1620825937374-87fc7d6bddc2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const Manifesto = () => (
  <section
    id="manifiesto"
    className="relative mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40"
    data-testid="manifesto"
  >
    <div className="grid gap-16 lg:grid-cols-[1fr_0.9fr] lg:gap-24">
      <div>
        <Overline>El Manifiesto</Overline>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mt-6 max-w-xl font-head text-4xl font-bold tracking-tight text-white md:text-5xl"
        >
          No vendemos seguridad. Construimos{" "}
          <span className="text-cyber-cyan text-glow-cyan">Cyber Defense</span>.
        </motion.h2>

        <div className="mt-14 space-y-2">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group flex gap-6 border-t border-white/10 py-7 transition-colors duration-500 hover:border-cyber-cyan/50"
            >
              <span className="font-mono-tech text-sm text-cyber-violet">{c.n}</span>
              <div>
                <h3 className="font-head text-xl font-semibold text-white transition-colors duration-300 group-hover:text-cyber-cyan md:text-2xl">
                  {c.title}
                </h3>
                <p className="mt-3 max-w-md font-sans text-sm leading-relaxed text-white/60 md:text-base">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="relative hidden self-start lg:block"
      >
        <div className="glass sticky top-28 overflow-hidden rounded-2xl">
          <img src={IMG} alt="Operaciones de seguridad" className="h-[34rem] w-full object-cover opacity-80" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#05070f] via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-cyber-cyan">
            // secure_ops :: cyvr_node_01
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
